import { useEffect as e, useRef as t } from "react";
//#region src/hooks/useKey.ts
var n = (n, r, i = ["keydown"], a = document) => {
	let o = t([]);
	e(() => {
		let e = typeof n == "string", t = e ? r : n, s = (r) => {
			e ? r.key === n && t(r) : t(r);
		};
		o.current.push(s);
		let c = (e) => {
			for (let t of o.current) t(e);
		}, l = Array.isArray(i) ? i : ["keydown"];
		for (let e of l) a.addEventListener(e, c);
		return () => {
			for (let e of l) a.removeEventListener(e, c);
			o.current = o.current.filter((e) => e !== s);
		};
	}, [
		n,
		r,
		i,
		a
	]);
};
//#endregion
export { n as default };

//# sourceMappingURL=useKey.js.map